import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const FormNavButtons = ({
  isFirstStep,
  isLastStep,
  isEditMode,
  setStep,
  publishButtonLabel,
  onPublish,
  onDiscard,
  nextButtonDisabled,
}) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <div className="event-form-nav-buttons">
      {!isFirstStep && (
        <button className="button button-gray" onClick={() => setStep((prevStep) => prevStep - 1)}>
          {t('eventManagement:common.back')}
        </button>
      )}
      {!isLastStep && (
        <button
          className="button button-black"
          onClick={() => setStep((prevStep) => prevStep + 1)}
          disabled={nextButtonDisabled}
        >
          {t('eventManagement:common.next')}
        </button>
      )}
      {/* TODO: Uncomment once API is ready */}
      {/* {isLastStep && (
        <button className="button button-black" onClick={() => onSaveDraft()}>
          Save as a draft
        </button>
      )} */}
      {isLastStep && isEditMode && (
        <button className="button button-gray" onClick={onDiscard}>
          {t('eventManagement:common.discardChanges')}
        </button>
      )}
      {isLastStep && (
        <button
          className="button button-black"
          type="submit"
          onClick={() => {
            onPublish()
          }}
          disabled={nextButtonDisabled}
        >
          {publishButtonLabel}
        </button>
      )}
    </div>
  )
}

FormNavButtons.propTypes = {
  isFirstStep: PropTypes.bool,
  isLastStep: PropTypes.bool,
  isEditMode: PropTypes.bool,
  setStep: PropTypes.func.isRequired,
  publishButtonLabel: PropTypes.string.isRequired,
  onSaveDraft: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  nextButtonDisabled: PropTypes.bool,
}

export default FormNavButtons
